import { useContext } from 'react';

import { ConfigContext } from '@providers/ConfigProvider';
import Typography from '@components/atoms/Typography';
import Button from '@components/atoms/Button';
import EnvelopeIcon from 'assets/icons/envelope.svg';
import { FormattedMessage } from 'utils/intl';

import classes from './ContactUs.module.scss';
import messages from './ContactUs.messages';

type Props = {
  className?: string;
};

const ContactUs = ({ className }: Props): JSX.Element => {
  const { contact } = useContext(ConfigContext);

  return (
    <div className={className}>
      <div className={classes.wrapper}>
        <div className={classes.topWrapper}>
          <span className={classes.msgWrapper}>
            <EnvelopeIcon className={classes.icon} />
            <Typography variant="h2" renderAs="span">
              <FormattedMessage {...messages.sendMessage} />
            </Typography>
          </span>
          <div className={classes.buttonWrapper}>
            <Button className={classes.button} href={`mailto:${contact.contactEmail}`} color="tertiary" size="lg">
              <span className={classes.buttonText}>
                <FormattedMessage {...messages.contactUs} />
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
